/** See `src/i18n/locales/en/manage.ts`. */
export const manage = {
  backToApp: 'Zurück zur App',
  sections: {
    companies: {
      label: 'Unternehmen',
      items: {
        companies: 'Unternehmen',
        pilots: 'Piloten',
      },
    },
    people: {
      label: 'Personen',
      items: {
        users: 'Alle Benutzer',
        linkIdentities: 'Identitäten verknüpfen',
        admins: 'Administratoren',
      },
    },
    audit: {
      label: 'Audit',
      items: {
        audit: 'Audit-Protokoll',
      },
    },
    subscriptions: {
      label: 'Abonnements',
      items: {
        config: 'Provider configuration',
        products: 'Produkte & Anbieter',
        userLedger: 'Benutzerkonto',
      },
    },
    system: {
      label: 'System',
      items: {
        statistics: 'Statistikstatus & Neuberechnung',
        requests: 'API-Anfragen',
      },
    },
    support: {
      label: 'Support',
      items: {
        tickets: 'Tickets',
      },
    },
    overview: {
      label: 'Übersicht',
      items: {
        overview: 'KPIs',
      },
    },
  },
  placeholders: {
    statistics: {
      title: 'Statistikstatus & Neuberechnung',
      note: 'Statistikstatus und Neuberechnungssteuerung sind ein eigenes Vorhaben — dieser Menüpunkt reserviert nur den Platz, der Bildschirm wird in Phase 1 nicht gebaut.',
    },
  },
  usersAll: {
    title: 'Alle Benutzer',
    linkIdentities: 'Identitäten verknüpfen',
    empty: 'Es existieren noch keine Identitäten.',
    name: 'Name',
    email: 'E-Mail',
    language: 'Sprache',
    login: 'Login',
    yes: 'ja',
    no: 'nein',
    view: 'Ansehen',
    rowsLabel: 'die Benutzer',
  },
  linkIdentities: {
    title: 'Doppelte Identitäten verknüpfen',
    lead: 'Der Alias bleibt bestehen, verweist aber auf die primäre Identität. Sofern du kein Plattformadministrator bist, muss eine der beiden loginlos sein, und die Identität mit Login wird die primäre — der Server prüft dies, unabhängig von der Auswahl hier.',
    candidatesLabel: 'die Personen, die du verwaltest',
    needTwo: 'Du benötigst mindestens zwei Personen in deinem Geltungsbereich, um zu verknüpfen.',
    aliasLabel: 'Alias (diese Identität wird zum Verweis)',
    primaryLabel: 'Primär (die Identität, die bestehen bleibt)',
    choose: 'Auswählen…',
    hasLogin: '(hat Login)',
    noLogin: '(kein Login)',
    link: 'Verknüpfen',
    cancel: 'Abbrechen',
  },
  erase: {
    completedTitle: 'Löschung abgeschlossen',
    completedText:
      'Die Identität ist gelöscht. Das Audit-Protokoll wird pseudonymisiert, nicht gelöscht; verknüpfte Identitäten bleiben mit zurückgesetztem Verweis bestehen.',
    departmentsWithoutAdmin: 'Abteilungen ohne Administrator zurückgeblieben: {{names}}',
    measurementsNotDeleted:
      'Messungen im Ingest-Dienst wurden NICHT gelöscht — diese Möglichkeit besteht dort noch nicht. Verfolge dies außerhalb des Dashboards weiter.',
    backToUsers: 'Zurück zu den Benutzern',
    title: 'Diese Person löschen',
    lead: 'Dies löscht die Identität {{userId}} unwiderruflich vollständig: ihre Benutzerzeile, Mitgliedschaften, Einwilligungen und Berechtigungen. Verknüpfte Identitäten bleiben bestehen; von Gengee stammende Daten bleiben erhalten; das Audit-Protokoll wird pseudonymisiert. Gib {{confirmWord}} zur Bestätigung ein.',
    confirmWord: 'ERASE',
    confirmationLabel: 'Bestätigung',
    erasePermanently: 'Endgültig löschen',
    cancel: 'Abbrechen',
  },
  requests: {
    title: 'API-Anfragen',
    lead: 'Die protokollierten Anfragen der Ingest-API für eine Quelle, neueste zuerst, optional auf ein Zeitfenster eingegrenzt.',
    filterSource: 'Nach Quelle filtern',
    sourcePlaceholder: 'Quellen-ID',
    filterFrom: 'Von',
    filterTo: 'Bis',
    filter: 'Filtern',
    enterSourceHint: 'Gib eine Quellen-ID ein, um deren Anfrageprotokoll zu laden.',
    empty: 'Keine Anfragen für diese Quelle und dieses Zeitfenster protokolliert.',
    when: 'Wann',
    method: 'Methode',
    path: 'Pfad',
    status: 'Status',
    rowsLabel: 'die Anfragen',
  },
} as const;
